class Configuration {
  // PRO
  static readonly INTEGRATOR_API_ENDPOINT =
    'https://virus-beacon.clinbioinfosspa.es/api';
  // LOCAL
  //static readonly INTEGRATOR_API_ENDPOINT = 'http://192.168.150.147:5052/api';

  static readonly GENE_API_ENDPOINT =
    'https://juliet.clinbioinfosspa.es:8443/prioCNVs/webservices/rest';
  static readonly ASSEMBLY_ID = 'NC_045512.2';
  static readonly DEFAULT_SEQUENCE_ID = 'NC_045512.2';
  static readonly BEACON_ID = 'SARS-CoV-2-beacon.clinbioinfosspa.es';
  static readonly BEACON_API_ID = 'v2.0';

  static readonly test = 1;
}

export default Configuration;
